import { canonicalCareTeamRole, DEFAULT_ADVANCED_SETTINGS } from '../../api/AdvancedSettingsProvider'

export const canAccessCareTeamChat = (
  roles: string[] | undefined,
  excludedRoles: string[] = DEFAULT_ADVANCED_SETTINGS.careTeamChatExcludedRoles
): boolean => !!roles?.length && !roles.some((role) => excludedRoles.includes(canonicalCareTeamRole(role)))
